import { render, staticRenderFns } from "./AverageCountTransactionChart.vue?vue&type=template&id=b5e11382&"
import script from "./AverageCountTransactionChart.vue?vue&type=script&lang=js&"
export * from "./AverageCountTransactionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports